import React from 'react';
import './IntroText.css';

const IntroText = () => (
  <div className='introtextcontainer'>
    <h1 className='introtitle'> About Me </h1>
    <p className='introtext'>
      Hi there!
      <br/>
      You are here means that you want to get to know me. Ok, so, you already know that my name is Akil Hylton.
      I am Jamaican, and growing up in both Jamaica and USA I can say that the weather here is increidible cold at times.
      But jokes aside, I am Computer Science Major with a minor in Math.
      I love JavaScript so when I learnt about React and what it was I began to find a new found love.

      Building something from scratch with nothing but a blank IDE and an idea is a satisfying feeling.
      One that I will continue to crave throughout my career as a developer.
      When I was younger growing up people would ask me what I want to do when I get older.
      I would always reply with, “I want to work at NASA” (National Aeronautics and Space Administration).
      Now many years later the childhood dream of working at the National Aeronautics and Space Administration is
      becoming more real with every program that I write and each project I build.
      You can say I'm drawn to the tech world due to it’s rapid change, however, I simply like to build things.
    </p>

    <p className='introtext'> To me I feel as if it is a superpower to be able to build anything that put my mind to.
      For example, I created a flash card app with React that helped me pass my Biology final with flying colors.I haven't doucmented my flashcard app on github but I will get to doing it sometime soon.
    </p>

  </div>
)


export default IntroText;



// WEBPACK FOOTER //
// ./src/container/IntroText/IntroText.js